import * as React from 'react';
type IconComplianceProps = React.SVGProps<SVGSVGElement>;

export const IconCompliance: React.FC<IconComplianceProps> = (props) => (
	<svg
		width={56}
		height={64}
		viewBox="0 0 56 64"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			x="0.333221"
			y="4.81702"
			width="49.3335"
			height="58.732"
			rx="4.69849"
			fill="#7EAE90"
		/>
		<rect
			x="6.33322"
			y="0.45105"
			width="49.3335"
			height="58.732"
			rx="4.69849"
			fill="#EBF8F0"
		/>
		<path
			d="M29.5903 12.0796L48.6187 12.0796"
			stroke="#FFA692"
			stroke-width="4.18593"
			stroke-linecap="round"
		/>
		<path
			d="M29.5903 31.108L48.6187 31.108"
			stroke="#FFA692"
			stroke-width="4.18593"
			stroke-linecap="round"
		/>
		<path
			d="M29.5903 48.0223L41.2188 48.0223"
			stroke="#FFA692"
			stroke-width="4.18593"
			stroke-linecap="round"
		/>
		<rect
			x="13.0093"
			y="7.85102"
			width="9.51424"
			height="9.51424"
			rx="1.05714"
			fill="#7EAE90"
			stroke="#7EAE90"
			stroke-width="2.11427"
		/>
		<rect
			x="12.9521"
			y="25.7653"
			width="9.62851"
			height="9.62851"
			rx="1.11427"
			stroke="#7EAE90"
			stroke-width="2"
		/>
		<rect
			x="12.9521"
			y="43.7366"
			width="9.62851"
			height="9.62851"
			rx="1.11427"
			stroke="#7EAE90"
			stroke-width="2"
		/>
		<path
			d="M14.0664 13.0472L16.4209 15.1027L21.4664 9.81702"
			stroke="#EBF8F0"
			stroke-width="2.11427"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export default IconCompliance;
